import { Box, Button, Link, Modal, Paper } from "@mui/material"
import { FC, useEffect, useState } from "react";
import StorylineServerProxy  from "../storyline-proxy/storyline-proxy";
import IconDelete from '@mui/icons-material/Delete';
import Paginator from "../GeneralComponents/paginator";
import { GenericStoryElementComponentProps, GenericStorylineElementsList } from "../GeneralComponents/generic-storyline-list";
import { Edit } from "@mui/icons-material";
import { LinkDetails } from "../scrap-reports-management/link-details";

export interface StoryElement{
    [x: string]: any;
    selectedForEngage: boolean | null;
    company: string;
    _id: string,
    title: string,
    link: string,
    description: string,
    timestamp: number,
    timestampFormatted: string,
    type: string,
    channelCategory: string | null,
    socialMedia: boolean | null,
    weeklyReview: boolean | null,
    gar: boolean | null,
    dsnaCategories: string[] | null,
    dsnaTitleOverride: string | null,
    dsnaImageURL: string | null,
    garTitleOverride: string | null,
    garDraftDate: string | null,
    archive: {
        png: string,
        html: string,
        pdf: string
    } | null;
}



export const StoryElementDisplay:FC<GenericStoryElementComponentProps> = ({ storyElement, updateListFromServer, handleEditClicked }) =>{

    async function handleDeleteStoryElement(storyElementId: string){
        StorylineServerProxy.deleteStoryElement(storyElementId).then(data => {
            updateListFromServer!();
        });
    }


    return (
        <Paper elevation={ 4 } sx= {{ padding: 1 }}>
            { storyElement.type } - <Link target="child" href={ storyElement.link }>
                { storyElement.title }
            </Link>
            <br/>
            { storyElement.company != null?<>Company: {storyElement.company}</>:<></> }
            <br/>
            { storyElement.description.split("\n").map(text => {
                return (<>{text} <br/></>)
             }) }
            { storyElement.archive?"Archives: ": "No archive" }
            { storyElement.archive?
                storyElement.archive.pdf?<><Link target="_blank" href={ "/archive" + storyElement.archive.pdf}>PDF</Link> - </>:"No PDF - ":""
            }
            { storyElement.archive?
                storyElement.archive.png?<><Link target="_blank" href={ "/archive/" + storyElement.archive.png}>PNG</Link> - </>:"No PNG - ":""
            }
            { storyElement.archive?
                storyElement.archive.html?<><Link target="_blank" href={ "/archive/" + storyElement.archive.html}>HTML</Link></>:"No HTML":""
            }
            <br />
            <Edit onClick={() => { handleEditClicked!(storyElement)} }></Edit>
            <IconDelete onClick={() => { console.log("Delete " + storyElement._id); handleDeleteStoryElement(storyElement._id); }}/>
        </Paper>
    )
}

export function StoryElementsList(){

    let [pageNumber, setPageNumber] = useState(0);
    let [storyElementsCount, setStoryElementsCount] = useState(0);
    const [pageSize, setPageSize] = useState(10);


    function updateList(){
        StorylineServerProxy.getStoryElementsCount().then(count => {  setStoryElementsCount(count.count) });
        StorylineServerProxy.getStoryElements(pageSize, pageNumber).then(elements => { setStoryElements(elements) });
    }

    let [storyElements, setStoryElements] = useState([] as any[]);
    let [elementOpen, setElementOpen] = useState(false);

    let [editedElement, setEditedElement] = useState(null);

    function handleCloseElement(){
        setElementOpen(false);
        updateList();
    }

    function handleEditClicked(storyElement){
        setEditedElement(storyElement);
        setElementOpen(true);
    }

    useEffect(() => {
        updateList();
    }, [pageNumber, pageSize]);


    

    return (
        <>
            <Paginator
                pageNumber={pageNumber}
                pageSize={pageSize}
                itemsCount={storyElementsCount}
                itemType={"story elements"}
                setPageNumber={setPageNumber}
                setPageSize={setPageSize}
            /> 
            <Modal sx={{ left: 100, top: 100, width:9/10, }} open={elementOpen} onClose={handleCloseElement}>
                <Paper sx={{ padding: 5, paddingBottom: 2 }} elevation={4}>
                    <LinkDetails link={""} scrapReport={null} existingElement={editedElement} handleCloseClicked={handleCloseElement} />
                    <Box sx={{ display:'flex', alignItems:'flex-end'}}  >
                        <Button sx={{ marginLeft: "auto" }} onClick={handleCloseElement}>Close</Button>
                    </Box>
                </Paper>
            </Modal>

            <GenericStorylineElementsList storyElements={storyElements} Component={StoryElementDisplay} updateListFromServer={updateList} handleEditClicked={handleEditClicked}/> 
        </>
    )
}